var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.311 4.18a.615.615 0 0 1 .189.436.593.593 0 0 1-.189.436L9.053 12l7.258 6.948a.617.617 0 0 1 .189.436.594.594 0 0 1-.189.436.647.647 0 0 1-.455.18.668.668 0 0 1-.455-.18L7.69 12.436A.615.615 0 0 1 7.5 12a.593.593 0 0 1 .189-.435L15.4 4.18A.646.646 0 0 1 15.856 4a.668.668 0 0 1 .455.18Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;